import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const InfoIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.75 10c0-4.55635 3.69365-8.25 8.25-8.25 4.5563 0 8.25 3.69365 8.25 8.25 0 4.5563-3.6937 8.25-8.25 8.25-4.55635 0-8.25-3.6937-8.25-8.25ZM10 .25C4.61522.25.25 4.61522.25 10c0 5.3848 4.36522 9.75 9.75 9.75 5.3848 0 9.75-4.3652 9.75-9.75 0-5.38478-4.3652-9.75-9.75-9.75ZM9.25 8.5c-.41421 0-.75.33579-.75.75s.33579.75.75.75v4.5c0 .4142.33579.75.75.75h.75c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75v-4.5c0-.41421-.3358-.75-.75-.75h-.75Zm1.875-2.625C11.125 6.49632 10.6213 7 10 7c-.62132 0-1.125-.50368-1.125-1.125S9.37868 4.75 10 4.75c.6213 0 1.125.50368 1.125 1.125Z" />
    </svg>
  );
};
